import{n as a,r as t,y as i}from"../../../493beda6.js";customElements.define("cai-icon-adobe-stock",class extends a{static get styles(){return t`
      :host {
        display: inline-block;
        width: var(--cai-icon-width, 16px);
        height: var(--cai-icon-height, 16px);
      }

      svg {
        width: 100%;
        height: 100%;
        fill: var(--cai-icon-fill, currentColor);
      }

      path {
      }
    `}render(){return i`<svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      preserveAspectRatio="xMidYMid meet"
      part="svg"
    >
      <path
        d="M13.21 16H2.79A2.79 2.79 0 0 1 0 13.21V2.79A2.79 2.79 0 0 1 2.79 0h10.42A2.79 2.79 0 0 1 16 2.79v10.42A2.79 2.79 0 0 1 13.21 16"
      />
      <path
        d="M10.076 11.233a1.6 1.6 0 0 1-.4-1.207v-2.75h-.663a.09.09 0 0 1-.088-.1V6.092a.088.088 0 0 1 .1-.1h.664c0-.1 0-.2.011-.326s.017-.245.028-.371l.033-.354c.011-.11.023-.208.038-.288a.117.117 0 0 1 .1-.1l1.294-.166c.059-.014.089.008.089.067a15.606 15.606 0 0 0-.039.692l-.011.426c-.004.148-.005.288-.005.421h1.018a.078.078 0 0 1 .088.089v1.117q0 .067-.077.077h-1.04v2.369a.909.909 0 0 0 .127.537.554.554 0 0 0 .47.172 1.551 1.551 0 0 0 .188-.011c.059-.007.122-.019.188-.033a.068.068 0 0 1 .077.077v.919q0 .121-.077.144a2.191 2.191 0 0 1-.465.122 3.69 3.69 0 0 1-.52.033 1.582 1.582 0 0 1-1.128-.372Zm-5.451.272a3.11 3.11 0 0 1-.848-.288.186.186 0 0 1-.077-.177V9.723a.065.065 0 0 1 .028-.061.053.053 0 0 1 .061.005 3.768 3.768 0 0 0 .985.431 3.808 3.808 0 0 0 1.018.144 1.6 1.6 0 0 0 .9-.194.573.573 0 0 0 .275-.48.641.641 0 0 0-.221-.476 2.814 2.814 0 0 0-.788-.459l-.554-.232a4.407 4.407 0 0 1-.847-.448 2.387 2.387 0 0 1-.537-.5 1.616 1.616 0 0 1-.277-.559 2.4 2.4 0 0 1-.076-.614 2.063 2.063 0 0 1 .172-.836 1.948 1.948 0 0 1 .5-.686 2.359 2.359 0 0 1 .83-.459 3.669 3.669 0 0 1 1.166-.166 6.682 6.682 0 0 1 .979.067 2.359 2.359 0 0 1 .748.221.16.16 0 0 1 .065.143v1.24a.1.1 0 0 1-.022.061q-.022.028-.077-.005a2.589 2.589 0 0 0-.769-.277 4.68 4.68 0 0 0-.935-.089 1.571 1.571 0 0 0-.9.188.56.56 0 0 0-.254.464.614.614 0 0 0 .221.46 2.857 2.857 0 0 0 .841.448l.409.166a5.311 5.311 0 0 1 .913.476 2.576 2.576 0 0 1 .576.515 1.673 1.673 0 0 1 .3.575 2.276 2.276 0 0 1 .088.637 2.059 2.059 0 0 1-.193.9 1.893 1.893 0 0 1-.559.686 2.688 2.688 0 0 1-.88.437 4.006 4.006 0 0 1-1.156.155 5.622 5.622 0 0 1-1.105-.096Z"
        fill="#fff"
      />
    </svg>`}});
